import * as injectTapEventPlugin from 'react-tap-event-plugin';
// tslint:disable-next-line:ordered-imports
import * as History from 'history';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import * as React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import 'react-select/dist/react-select.css';
import { RoutesModel } from './models';
// tslint:disable-next-line:ordered-imports
import './styles.css';
injectTapEventPlugin();

const browserHistory = History.createBrowserHistory();

class Routes extends React.Component {

    public renderRoutes() {
        const keys = Object.keys(RoutesModel.Model)
        return keys.map((k: any) => {
            const routes = Object.keys(RoutesModel.Model[k]).map((kk: any, ii: number) => {
                return <Route key={ii} path={RoutesModel.Model[k][kk].route} exact={RoutesModel.Model[k][kk].exact} component={RoutesModel.Model[k][kk].controller} />
            })
            if (Object.keys(RoutesModel.Model[k]).length > 1) {
                return (
                    <Switch key={k}>
                        {routes}
                    </Switch>
                )
            } else {
                return routes
            }
        })
    }

    public render() {
        return (
            <MuiThemeProvider>
                <Router history={browserHistory}>
                    <div>
                        {this.renderRoutes()}
                    </div>
                </Router>
            </MuiThemeProvider>
        );
    }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.tsx